import { render, staticRenderFns } from "./AssignUsers.vue?vue&type=template&id=6417745e&scoped=true"
import script from "./AssignUsers.vue?vue&type=script&lang=js"
export * from "./AssignUsers.vue?vue&type=script&lang=js"
import style0 from "./AssignUsers.vue?vue&type=style&index=0&id=6417745e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.30_css-loader@6.11.0_webpack@5.105.4__lodash@4.18.1_webpack@5.105.4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6417745e",
  null
  
)

export default component.exports